import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePopup } from '../App';
import appConfig from '../config/appConfig';

const HomeLandingPage = () => {
  const navigate = useNavigate();
  const { showPopup } = usePopup();
  const logoSrc = `${appConfig.basePath.replace(/\/$/, '')}/logo.png`;

  const handleSignUpClick = () => {
    showPopup(); // Show the popup instead of navigating directly
  };

  const handleStatusClick = () => {
    navigate('/status');
  };

  const handleAdminClick = () => {
    navigate('/admin');
  };

  return (
    <div className="landing-page">
      
      <div className="landing-content">
        <div className="landing-logo">
        <img src={logoSrc} alt="DUI First Time Offender Program Logo" className="landing-logo-img" />
      </div>
        <h1>Welcome to <br /> DUI First Time Offender Program</h1>
        <p>Please select an option to proceed:</p>
        <div className="button-group">
          <button onClick={handleSignUpClick}>Apply</button>
          <button onClick={handleStatusClick}>Check Status</button>
          <button onClick={handleAdminClick}>Admin</button>
        </div>
      </div>
    </div>
  );
};

export default HomeLandingPage;